import { CardInfo } from './card-info.model';
import { NotificationInfo } from './notification-info.model';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class AlertCardInfo extends CardInfo {
  notification: NotificationInfo = new NotificationInfo();
}
